// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__Cj8DL","label":"Completed_label__30SuQ"};